export default __webpack_public_path__ + "static/media/logo-conservatorio-website.ddc6e1c4.png";